module.exports = __webpack_public_path__ + "img/empty-state-dashboard-2.c09620e4.png";